import React from "react";

const CoverAlbum = ({ image }) => {
  return <img src={image} alt="cover-album" />;
};

export default CoverAlbum;
